// extracted by mini-css-extract-plugin
export default {"canvasHolder":"about_canvasHolder__kwzdu","uiHolder":"about_uiHolder__v-HUW","textSection":"about_textSection__y25xf","emailForm":"about_emailForm__Ta1pu"};